module.exports = __webpack_public_path__ + "img/main-casino.24c44a78.png";